import axios from 'axios';

const USER_API_BASE_URL = process.env.REACT_APP_API_URL + '/api/repair';

class RepairService {

    fetchRepairById(repairId, customerCode, siteCode) {
        return axios({
            url: USER_API_BASE_URL + '/' + repairId,
            method: 'GET',
            headers: {
                'code-site': siteCode,
                'code-client': customerCode
            }
        })
    }

    fetchRepairInterventionById(repairId, customerCode, siteCode) {
        return axios({
            url: USER_API_BASE_URL + '/intervention/' + repairId,
            method: 'GET',
            headers: {
                'code-site': siteCode,
                'code-client': customerCode
            }
        })
    }

    getAttachedRepairFile(espaceStockage, referenceMetier) {
        return axios({
            url: USER_API_BASE_URL + '/piecesJointes/' + espaceStockage + '/' + referenceMetier,
            method: 'GET',
            responseEncoding: 'binary',
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/octet-stream'
            }
        })
    }

    fetchRepairByCase(caseId, customerCode, siteCode) {
        return axios({
            url: USER_API_BASE_URL + '/case/' + caseId,
            method: 'GET',
            headers: {
                'code-site': siteCode,
                'code-client': customerCode
            }
        })
    }

    fetchSearchRepairs(filters, messagesIndicator, isSuivi) {
        let filtersIndicator = {
            ...filters,
            messagesIndicator : messagesIndicator,
            isSuivi : isSuivi
        }
        return axios({
            url: USER_API_BASE_URL + '/advanced-search',
            method: 'post',
            data: filtersIndicator,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            }
        })
    }
}

export default new RepairService();